import React from 'react'
import { Route, BrowserRouter, Switch } from 'react-router-dom'

import App from './app'
import Login from '../pages/Login/Login';

export default () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route path='/login' component={Login} />
                <App />
            </Switch>
        </BrowserRouter>
    )
}


// WEBPACK FOOTER //
// ./src/route/root.js